import { Popup } from 'react-leaflet';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LabelImportantOutlinedIcon from '@mui/icons-material/LabelImportantOutlined';
import { TsunamiOutlined } from '@mui/icons-material';

function PopupLayer({ quake }) {
  if (!quake || !quake.properties || !quake.properties.mag) return;
  return (
    <Popup>
      <div className="quake__main">
        <div
          className="quake__title"
          style={{
            color: quake.properties.alert
              ? `var(--color-${quake.properties.alert})`
              : '',
          }}
        >
          {quake.properties.mag.toFixed(1)}
        </div>
        <span className="quake__unit">
          {quake.geometry.coordinates[2].toFixed(1)}m
        </span>
      </div>
      <div>
        <p className="quake__unit">
          <CalendarMonthOutlinedIcon />{' '}
          {new Date(quake.properties.time).toLocaleString()}
        </p>
        <p className="quake__details">
          <LocationOnOutlinedIcon />{' '}
          {quake.properties.place[0].toUpperCase() +
            quake.properties.place.slice(1)}
        </p>
        <p className="quake__unit sig">
          <span>
            <LabelImportantOutlinedIcon /> Significance: {quake.properties.sig}
          </span>
          {quake.properties.tsunami === 1 && (
            <span className="tsunami">
              <TsunamiOutlined /> Tsunami warning
            </span>
          )}
        </p>
      </div>
    </Popup>
  );
}

export default PopupLayer;
